module.exports = __webpack_public_path__ + "img/GSP.9b735b47.webp";